import { Button, Form, Input, Modal } from "antd";

const AppChangePasswordModal = ({ open, onClose, onSubmit }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    if (onSubmit) {
      onSubmit(values);
    }
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      closable={false}
      maskClosable={false}
      centered
      title={
        <h2 style={{ textAlign: "center", fontWeight: 600 }}>
          Change Password
        </h2>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        {/* Old Password */}
        <Form.Item
          label="Old Password"
          name="oldPassword"
          rules={[
            { required: true, message: "Please enter your old password" },
          ]}
        >
          <Input.Password placeholder="Enter Here" />
        </Form.Item>

        {/* New Password */}
        <Form.Item
          label="New Password"
          name="newPassword"
          rules={[
            { required: true, message: "Please enter your new password" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password placeholder="Enter Here" />
        </Form.Item>

        {/* Confirm Password */}
        <Form.Item
          label="Confirm Password"
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Please confirm your password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords do not match"));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Enter Here" />
        </Form.Item>

        {/* Submit button */}
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            style={{
              background: "linear-gradient(90deg, #00C6FF 0%, #0072FF 100%)",
              border: "none",
              borderRadius: "6px",
              fontWeight: 600,
            }}
          >
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default constore(AppChangePasswordModal);
